<template>
    <div
        class="ph-empty"
        :class="[
            `ph-empty--${size}`,
            { 'ph-empty--search': isSearch }
        ]"
    >
        <template v-if="size === 'compact'">
            <div class="ph-empty__mini" aria-hidden="true">
                <span class="ph-empty__mini-line"></span>
                <span class="ph-empty__mini-line is-short"></span>
                <span class="ph-empty__mini-line is-shorter"></span>
            </div>
            <span class="ph-empty__label">{{ text }}</span>
        </template>
        <template v-else>
            <div class="ph-empty__visual" aria-hidden="true">
                <div class="ph-empty__orb"></div>
                <svg
                    class="ph-empty__svg"
                    viewBox="0 0 88 88"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <defs>
                        <linearGradient :id="gradId" x1="12" y1="8" x2="76" y2="80" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#01A2FD" stop-opacity="0.18" />
                            <stop offset="1" stop-color="#1769FA" stop-opacity="0.06" />
                        </linearGradient>
                    </defs>
                    <circle cx="44" cy="44" r="34" :fill="`url(#${gradId})`" />
                    <template v-if="isSearch">
                        <rect x="24" y="30" width="34" height="26" rx="5" fill="#fff" stroke="#01A2FD" stroke-width="1.5" stroke-opacity="0.35" />
                        <path d="M32 40H50" stroke="#01A2FD" stroke-width="2" stroke-linecap="round" stroke-opacity="0.22" />
                        <path d="M32 46H44" stroke="#01A2FD" stroke-width="2" stroke-linecap="round" stroke-opacity="0.16" />
                        <circle cx="56" cy="52" r="9" stroke="#01A2FD" stroke-width="2" stroke-opacity="0.55" />
                        <path d="M62 58L68 64" stroke="#01A2FD" stroke-width="2.5" stroke-linecap="round" stroke-opacity="0.55" />
                    </template>
                    <template v-else>
                        <rect x="20" y="34" width="36" height="28" rx="5" fill="#EAF6FF" stroke="#01A2FD" stroke-width="1.2" stroke-opacity="0.25" />
                        <rect x="28" y="26" width="36" height="28" rx="5" fill="#fff" stroke="#01A2FD" stroke-width="1.5" stroke-opacity="0.45" />
                        <path d="M36 36H56" stroke="#01A2FD" stroke-width="2" stroke-linecap="round" stroke-opacity="0.35" />
                        <path d="M36 42H52" stroke="#01A2FD" stroke-width="2" stroke-linecap="round" stroke-opacity="0.24" />
                        <path d="M36 48H46" stroke="#01A2FD" stroke-width="2" stroke-linecap="round" stroke-opacity="0.16" />
                        <circle cx="62" cy="24" r="3.5" fill="#01A2FD" fill-opacity="0.28" />
                        <circle cx="22" cy="58" r="2.5" fill="#1769FA" fill-opacity="0.22" />
                    </template>
                </svg>
            </div>
            <p class="ph-empty__label">{{ text }}</p>
            <p v-if="subtext" class="ph-empty__sub">{{ subtext }}</p>
        </template>
    </div>
</template>

<script>
export default {
    name: 'PhEmpty',
    props: {
        text: {
            type: String,
            default: '暂无内容'
        },
        subtext: {
            type: String,
            default: ''
        },
        size: {
            type: String,
            default: 'page',
            validator: val => ['compact', 'panel', 'page', 'table'].includes(val)
        }
    },
    computed: {
        gradId() {
            return `ph-empty-grad-${this._uid}`
        },
        isSearch() {
            return !!this.subtext
        }
    }
}
</script>

<style lang="less" scoped>
.ph-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    box-sizing: border-box;
}

.ph-empty__visual {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 0;
}

.ph-empty__orb {
    position: absolute;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(1, 162, 253, 0.12) 0%, rgba(1, 162, 253, 0) 70%);
    pointer-events: none;
}

.ph-empty__svg {
    position: relative;
    z-index: 1;
    display: block;
    user-select: none;
    pointer-events: none;
}

.ph-empty__label {
    margin: 0;
    color: #8a94a6;
    line-height: 1.5;
    letter-spacing: 0.2px;
}

.ph-empty__sub {
    margin: 8px 0 0;
    font-size: 12px;
    color: #b0b8c4;
    line-height: 1.5;
}

.ph-empty__mini {
    width: 40px;
    height: 32px;
    border-radius: 7px;
    border: 1px dashed rgba(1, 162, 253, 0.28);
    background: linear-gradient(180deg, rgba(234, 246, 255, 0.95) 0%, rgba(245, 251, 255, 0.45) 100%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    box-sizing: border-box;
}

.ph-empty__mini-line {
    display: block;
    width: 18px;
    height: 2px;
    border-radius: 1px;
    background: rgba(1, 162, 253, 0.24);

    &.is-short {
        width: 14px;
        background: rgba(1, 162, 253, 0.16);
    }

    &.is-shorter {
        width: 10px;
        background: rgba(1, 162, 253, 0.1);
    }
}

.ph-empty--compact {
    gap: 8px;
    min-height: 88px;
    padding: 12px 8px;

    .ph-empty__label {
        font-size: 12px;
        color: #b0b8c4;
    }
}

.ph-empty--panel {
    width: 100%;
    height: 100%;
    min-height: 180px;
    padding: 16px;

    .ph-empty__orb {
        width: 96px;
        height: 96px;
    }

    .ph-empty__svg {
        width: 72px;
        height: 72px;
    }

    .ph-empty__label {
        margin-top: 14px;
        font-size: 13px;
    }
}

.ph-empty--page {
    padding: 52px 24px 60px;

    .ph-empty__orb {
        width: 120px;
        height: 120px;
    }

    .ph-empty__svg {
        width: 88px;
        height: 88px;
    }

    .ph-empty__label {
        margin-top: 18px;
        font-size: 14px;
    }
}

.ph-empty--table {
    padding: 40px 16px;

    .ph-empty__orb {
        width: 100px;
        height: 100px;
    }

    .ph-empty__svg {
        width: 76px;
        height: 76px;
    }

    .ph-empty__label {
        margin-top: 14px;
        font-size: 13px;
    }
}

.ph-empty--search {
    .ph-empty__label {
        color: #7a8494;
    }
}
</style>
